import * as React from 'react';
import { Container, Grid, Typography } from '@mui/material';
import CardService from '../components/CardService';

export default function Services() {

    return (                                    
        <Container sx={{ marginTop:4, marginBottom:4 }}>                               
            <Grid container spacing={4}>
                <Grid size={12}>                  
                    <Typography variant='h3' fontWeight={'bold'} sx={{ textAlign: 'center' }}>Servicios</Typography>
                    <Typography variant='h6' sx={{ mt:2, mb:2, ml: { xs:0, md:0, lg: 20}, mr: { xs:0, md:0, lg: 20}, textAlign: 'center' }}>
                        OK Engineering S.A. se especializa en el diseño y fabricación de maquinas de alta tecnología 
                        orientadas a la industria de la carpintería de aluminio y PVC. Incursionando en otras áreas 
                        aplicando el Know how adquirido.
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 3, lg: 3}} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CardService title='Venta' description='Venta de equipamientos de alta tecnología para carpinterías de aluminio y PVC.' />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 3, lg: 3}} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CardService title='Asesoramiento' description='El staff de asesores técnicos está compuesto por profesionales altamente 
                    capacitados para poder brindarle todas las respuestas en cuanto a usos y características de los equipos.' />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 3, lg: 3}} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CardService title='Diseño' description='Diseñamos y construimos equipamiento de alta tecnología para agilizar y facilitar 
                    la producción de su empresa.' />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 3, lg: 3}} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CardService title='Capacitación' description='Brindamos capacitaciones por personal altamente especializado sobre el uso 
                    de las distintas herramientas provistas por la empresa.' />
                </Grid>
            </Grid>
        </Container>                        
    )
}